// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".step-parcours .callout-parcours{position:relative}.step-parcours .controls{position:absolute;top:0.5rem;right:0.5rem}.step-parcours .controls .btn{margin-left:0.5rem}\n", ""]);
// Exports
module.exports = exports;
